import React, { useEffect, useState } from "react";
import StoreAPI from "../../api/StoreApi";

function StoreList({ onStoreSelect }) {
  const [storeList, setStoresList] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    loadAllStores(searchText);
  }, [searchText]);

  const loadAllStores = async (inputValue = "") => {
    try {
      const res = await StoreAPI.getListforDropdown({
        search: inputValue,
      });
      if (res.code === 200) {
        setStoresList(res.data);
      }
    } catch (err) {}
  };

  const updateSelectedStore = async (name = "", id = "") => {
    await onStoreSelect(name, id);
    document.getElementById("offcanvasCloser")?.click();
  };

  return (
    <>
      <div className="offcanvas-header">
        <h5 id="offcanvasRightLabel">Store Listing</h5>
        <button
          type="button"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          id="offcanvasCloser"
        />
      </div>
      {/* end offcanvas-header*/}
      <div className="offcanvas-body">
        <div className="text-end">
          <a
            type="button"
            className="text-info"
            onClick={(e) => updateSelectedStore("Select Store", null)}
          >
            Deselect Store
          </a>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" id="basic-addon1">
            <i className="ti ti-search" />
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Search By Store Name"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        {storeList.length > 0 ? (
          storeList.map((store, index) => (
            <a
              type="button"
              onClick={(e) => updateSelectedStore(store.name, store._id)}
              className="alert alert-primary alert-dismissible custom-alert-icon shadow-sm d-flex align-items-center"
              role="alert"
              key={store._id}
            >
              {store.logo ? (
                <img
                  src={store.logo}
                  className="img-fluid rounded"
                  width="25"
                />
              ) : (
                <i className="fa fa-building"></i>
              )}

              <span className="storelistingdata ms-2">{store.name}</span>
            </a>
          ))
        ) : (
          <span>No Store Available with this title</span>
        )}
      </div>
    </>
  );
}

export default StoreList;
